import { Vector as VectorLayer } from 'ol/layer';
import { Vector as VectorSource } from 'ol/source';
import { Draw } from 'ol/interaction';
import { Style } from 'ol/style';

import { Point } from 'ol/geom';
declare const google: any;
export function googleView(
  map: any,
  mapService: any,
  toolName: any,
  counter: any,
  toolActive: any,
  ipAddress: any
): any {
  // let draw: any;
  let sketch: any;
  let qlat = '';
  let qlng = '';
  let zoom: any;
  const streetViewSource = new VectorSource();
  mapService.streetViewLayer = new VectorLayer({
    source: streetViewSource,
  });
  map.addLayer(mapService.streetViewLayer);

  getDistance();
  function getDistance() {
    map.removeInteraction(mapService.drawBox);
    mapService.streetViewLayer.getSource().clear();
    mapService.getdrawEnable(true);
    if (counter == 1) {
      addInteraction();
    }
  }
  function addInteraction() {
    const drawType = 'Point';
    const layer = mapService.streetViewLayer;
    mapService.drawBox = new Draw({
      source: layer.getSource(),
      type: drawType,
      style: new Style({}),
    });
    map.addInteraction(mapService.drawBox);
    mapService.drawBox.on('drawstart', (evt: any) => {
      sketch = evt.feature;
      mapService.streetViewLayer.getSource().clear();
    });
    mapService.drawBox.on('drawend', (evt: any) => {
      toolActive = false;
      mapService.previousId = null;
      qlat = '';
      qlng = '';
      mapService.streetViewLayer.getSource().clear();
      sketch = evt.feature;
      const geom = evt.feature.getGeometry();
      if (geom instanceof Point) {
        mapService.counter = 0;
        const temp: any = geom.transform('EPSG:3857', 'EPSG:4326');
        const oo = temp.getCoordinates();
        qlat = oo[1];
        qlng = oo[0];
        zoom =
          map.getView().getZoom() +
          mapService.mapData.map_data.map_data.minzoom;
        goToGoogleMaps(parseFloat(qlat), parseFloat(qlng));
        mapService.allBtns.forEach((elem: any) => {
          elem.classList.remove('active');
        });
        mapService.previousId = null;
        map.removeInteraction(mapService.drawBox);
      }
      sketch = null;
    });
  }
  function goToGoogleMaps(tlat: any, tlng: any) {
    const sv = new google.maps.StreetViewService();
    sv.getPanoramaByLocation(
      new google.maps.LatLng(tlat, tlng),
      100,
      (data: any, status: any) => {
        if (status == 'OK') {
          const clat = data.location.latLng.lat();
          const clng = data.location.latLng.lng();
          const bearing =
            -90 - (Math.atan2(clat - tlat, clng - tlng) * 180) / Math.PI;
          const url =
            'https://maps.google.com/maps?q=' +
            tlat +
            ',' +
            tlng +
            '&cbll=' +
            clat +
            ',' +
            clng +
            '&layer=c&cbp=0,' +
            bearing +
            ',0,0,0';
          // window.location.href = url;
          window.open(url, '_blank');
        } else {
          // No StreetView image nearby...
          const url =
            'https://maps.google.com/maps?q=' +
            tlat +
            ',' +
            tlng +
            '&ll=' +
            tlat +
            ',' +
            tlng +
            '&z=' +
            (zoom || 16);
          // window.location.href = url;
          window.open(url, '_blank');
        }
        if (toolName.displayName === 'Metrics') {
          mapService.getdrawEnable(true);
        } else {
          mapService.getdrawEnable(false);
        }
      }
    );
    mapService.activityLoging('GoogleStreetView:Go', ipAddress);
  }
}
